import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { ErrorFilledIcon, WarningFilledIcon, CheckmarkFilledIcon } from '@cognite/cogs-icons';
import { getThemeClassNames } from '@cognite/cogs-utils';

var iconMap = {
  error: ErrorFilledIcon,
  warning: WarningFilledIcon,
  success: CheckmarkFilledIcon
};
var Message = function Message(_a) {
  var children = _a.children,
    className = _a.className,
    _a$appearance = _a.appearance,
    appearance = _a$appearance === undefined ? 'error' : _a$appearance,
    text = _a.text,
    inverted = _a.inverted,
    otherProps = __rest(_a, ["children", "className", "appearance", "text", "inverted"]);
  var textArray = typeof text === 'string' ? [text] : text;
  if (!textArray.length) return null;
  var Icon = iconMap[appearance];
  return jsxs("span", Object.assign({
    className: classNames('cogs-v10', 'cogs-messages', className)
  }, otherProps, {
    children: [children, textArray === null || textArray === undefined ? undefined : textArray.map(function (line) {
      return jsxs("span", {
        className: classNames.apply(undefined, ['cogs-v10', "cogs-messages--cogs-message", "cogs-messages--cogs-message--" + appearance].concat(getThemeClassNames(inverted))),
        children: [jsx(Icon, {
          className: classNames('cogs-v10', 'cogs-messages--cogs-message--icon')
        }), line]
      }, line);
    })]
  }));
};

export { Message };
